import {PANEL_SET_PARAM} from '~/frontend/src/constants';

export type SetParamAction = {
    type : typeof PANEL_SET_PARAM;
    panelKey : string;
    paramKey : string;
    paramValue : any;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} paramKey
 * @param {any} paramValue
 *
 * @return {SetParamAction}
 */
export default function setParam( panelKey : string, paramKey : string, paramValue : any ) : SetParamAction {
    return {
        type: PANEL_SET_PARAM,
        panelKey,
        paramKey,
        paramValue
    };
}

export type SetParam = typeof setParam;
